import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

export function getBurialMethod(id: number): JQueryPromise<modelsGet.IBurialMethod>
{
    var endpoint = new URI("api/burialmethods");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IBurialMethod>({
        endpoint: endpoint.href()
    });
}

export function getBurialMethods(): JQueryPromise<modelsGet.IBurialMethod[]>
{
    var endpoint = new URI("api/burialmethods");

    return api.get<modelsGet.IBurialMethod[]>({
        endpoint: endpoint.href()
    });
}

export function post(burialMethod: modelsPost.IBurialMethod): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/burialmethods",
        data: JSON.stringify(burialMethod)
    });
}

export function put(id: number, burialMethod: modelsPost.IBurialMethod): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/burialmethods/${id}`,
        data: JSON.stringify(burialMethod)
    });
}

export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/burialmethods/${id}`
    });
}